/**
 * La Tienda Del Padel — FAQ Accordion
 * Handles open/close of FAQ items with only one open at a time.
 */
(function () {
  'use strict';

  function initAccordion(accordion) {
    const questions = accordion.querySelectorAll('.faq-question');

    questions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const answerId = btn.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);

        if (!answer) return;

        // Close all other items
        questions.forEach(function (otherBtn) {
          if (otherBtn !== btn) {
            otherBtn.setAttribute('aria-expanded', 'false');
            var otherAnswer = document.getElementById(otherBtn.getAttribute('aria-controls'));
            if (otherAnswer) otherAnswer.hidden = true;
          }
        });

        // Toggle current item
        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  // Initialize all accordions on the page
  document.addEventListener('DOMContentLoaded', function () {
    var accordions = document.querySelectorAll('[data-faq-accordion]');
    accordions.forEach(initAccordion);
  });

  // Re-initialize on Shopify section render (theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var accordion = e.target.querySelector('[data-faq-accordion]');
      if (accordion) initAccordion(accordion);
    });
  }
})();
